export enum AccountEventAction {
    ACCOUNT_SIDEBAR_MENU_CLICKED = 'navigation click',
    ACCOUNT_SIDEBAR_LOYALTY_CLICKED = 'cta click',
    ACCOUNT_SIDEBAR_SHOWCASE_CLICKED = 'promotion click',
    ACCOUNT_LOYALTY_POINTS_INFO_LINK_CLICKED = 'cta click',
    ACCOUNT_NONLOYALTY_ENROLLMENT_LINK_CLICKED = 'click',
    ACCOUNT_NONLOYALTY_ENROLLMENT_SIGNUP_CLICKED = 'sign up overlay display'
}
